import React from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import FileUpload from "../../Component/FileUpload/FileUpload";

const AddNews = () => {
  return (
    <Container fluid className="news-page">
      <div className="news-head">
        <div>
          <p>Home / Add News</p>
          <h1>Add News</h1>
        </div>
        <Link to="/dashboard/news" className="dashboard-panel-link">
          View news
        </Link>
      </div>
      <FileUpload mode="add" />
    </Container>
  );
};

export default AddNews;
